import { FC } from 'react'
import { InputGroup, Text } from '@blueprintjs/core'
import { Link } from '@inertiajs/react'
import { Button } from 'client/components/Button/Button'
import { GradientBorder } from 'client/components/GradientBorder/GradientBorder'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import Cross from 'images/cross.svg?react'
import Logo from 'images/logo.svg?react'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const Header: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.Common)
  return (
    <header className="relative flex w-full justify-center">
      <ResponsiveBlock className="flex w-full" contentClassName="gap-8 justify-between items-center">
        <Link
          href="/"
          className="flex items-center gap-4 text-palette-white hover:text-palette-white hover:no-underline"
        >
          <Logo className="h-9" />
          <Text tagName="span" className="font-title---50px uppercase">
            D-console
          </Text>
        </Link>
        <Button className="font-body---20px h-12 px-8">{t('header.button')}</Button>
        {/* <GradientBorder className="h-20 flex-1 px-4">
          <div className="flex w-full items-center gap-8">
            <InputGroup
              className="border-none"
              inputClassName="font-body---14px uppercase outline-hidden bg-transparent focus:shadow-none"
              placeholder="search for products or services"
              value=""
              onValueChange={() => {}}
              large
              fill
            />
            <Cross className="flex-none" />
            <Button>Search</Button>
          </div>
        </GradientBorder> */}
      </ResponsiveBlock>
    </header>
  )
}

export { Header }
